import { render, staticRenderFns } from "./DashSingleValueLoading.vue?vue&type=template&id=b5a33038"
import script from "./DashSingleValueLoading.vue?vue&type=script&lang=js"
export * from "./DashSingleValueLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports